import React, { useEffect } from 'react';
import { useToggleLocalMute, useLocalVideo, PreviewVideo, useMeetingManager, useSelectVideoQuality } from 'amazon-chime-sdk-component-library-react';
import { useStore, StoreTypes } from 'context';
import LiveStreamStatusMeter from 'components/LiveStreamStatusMeter';
import styles from './index.module.scss';
import classnames from 'classnames';
import Icon from 'components/Icon';
import { ReaderEvent } from 'events/EventTypes';
import { EventBus } from 'events/EventBus';
import { Roles } from 'constants/role';

const LiveStreamLocalVideo = ({ className, streaming = false }) => {
  const [{ isFullVideo }] = useStore(StoreTypes.course);
  const [{ role }] = useStore(StoreTypes.user);
  const meetingManager = useMeetingManager();
  const selectVideoQuality = useSelectVideoQuality();
  const selfAttendeeId = meetingManager.configuration.credentials.attendeeId;
  const externalUserId = meetingManager.configuration.credentials.externalUserId;
  const userId = externalUserId.split('$')[0];
  const [{ name: userName }] = useStore(StoreTypes.user);

  const { isVideoEnabled, toggleVideo } = useLocalVideo();
  const { muted, toggleMute } = useToggleLocalMute();

  useEffect(() => {
    isFullVideo?selectVideoQuality('720p'):selectVideoQuality('360p')
  }, [isFullVideo,selectVideoQuality])

  useEffect(() => {
    if (streaming && muted) {
      toggleMute();
    }

    if (!streaming && !muted) {
      toggleMute();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[streaming])

  useEffect(() => {
    if (streaming && !isVideoEnabled) {
      toggleVideo();
    }

    if (!streaming && isVideoEnabled) {
      toggleVideo();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [streaming]);

  const videoFullScreenHandler = (isFull) => {
    EventBus.emit({ event: ReaderEvent.sendFullVideoEvent, payload: { isFullVideo: isFull } });
  }

  return <div className={classnames(styles.localVideo, className)}>
    {/* {
      streaming && isVideoEnabled && <LocalVideo className={styles.video} />
    } */}
    <PreviewVideo className={styles.video} />
    {
      role=== Roles.ONECLASS_TEACHER&&<div>

        <div
          className={classnames(styles.offFullVideoBtn, { [styles.offFullVideoBtnHide]: !isFullVideo })}
          onClick={() => videoFullScreenHandler(false)}
        >
          <Icon name="OffFullVideoOver" />
          <Icon name="OffFullVideoOut" />
        </div>
        <div className={classnames(styles.fullVideoBtn, { [styles.fullVideoBtnHide]: isFullVideo })}
          onClick={() => videoFullScreenHandler(true)}
        >
          <Icon name="FullVideoOver" />
          <Icon name="FullVideoOut" />
        </div>
      </div>
    }
    {
      selfAttendeeId && <LiveStreamStatusMeter userName={userName} attendeeId={selfAttendeeId} />
    }
  </div>
};


export default LiveStreamLocalVideo;